<template>
  <b-card no-body class="mb-3">
    <b-card-header>
      {{ fullName }}
      <span v-if="candidate.email_address">-</span>
      <b-link
        v-if="candidate.email_address"
        :href="`mailto:${candidate.email_address}`"
        target="_top"
      >
        {{ candidate.email_address }}</b-link
      >
    </b-card-header>
    <b-card-body class="CandidateInfo__card-body">
      <b-form-group label-cols-sm="3" label-class="py-0" label="Expertise:">
        {{ candidate.tags_name || '-' }}
      </b-form-group>
      <b-form-group label-cols-sm="3" label-class="py-0 m-0" label="Locations:">
        {{ candidate.locations_name || '-' }}
        <div v-if="candidate.regions_name">
          {{ candidate.regions_name }}
        </div>
      </b-form-group>
      <b-form-group label-cols-sm="3" label-class="py-0 m-0" label="Day Rate:">
        {{ candidate.minimum_day_rate_description || '-' }}
      </b-form-group>
      <b-form-group
        label-cols-sm="3"
        label-class="py-0"
        label="Days Available:"
      >
        {{ candidate.availability_description || '-' }}
      </b-form-group>
      <b-form-group
        label-cols-sm="3"
        label-class="py-0 m-0"
        label="References:"
      >
        <ReferencesModal :candidate="candidate" link />
      </b-form-group>
      <b-form-group
        label-cols-sm="3"
        label-class="py-0 m-0"
        label="Additional Information:"
      >
        <AdditionalInformationModal :candidate="candidate" link />
      </b-form-group>
    </b-card-body>
  </b-card>
</template>

<script>
import ReferencesModal from '../ReferencesModal/ReferencesModal'
import AdditionalInformationModal from '../AdditionalInformationModal/AdditionalInformationModal'

export default {
  name: 'CandidateInfo',
  components: {
    ReferencesModal,
    AdditionalInformationModal
  },
  props: {
    candidate: {
      type: Object,
      required: true
    }
  },
  computed: {
    fullName() {
      return `${this.candidate.first_name} ${this.candidate.last_name}`
    },
    emailAddress() {
      return this.candidate.email_address || '-'
    },
    site() {
      return this.candidate.website &&
        this.candidate.website.indexOf('http') === -1
        ? `http://${this.candidate.website}`
        : this.candidate.website
    }
  }
}
</script>

<style lang="scss">
.CandidateInfo__card-body {
  .form-group {
    margin-bottom: 0.5rem;
  }
}
.CandidateInfo__additiona-info {
  overflow-wrap: anywhere;
}
</style>
